<template>

  <div>
<div class="row">
  <div class="col-2">
    <CCard class="card">
            <div class="step001">
        <img src="@/assets/visitor.png"  style="width:46px;height:40px"/>
        <span class="head">Visitors</span>
        <span class="step002" ><a href="#/customer" style="color:red;text-decoration:none">{{visitors}}</a></span>
        <span class="step003">Total Visitors</span>
      </div>

    </CCard>
  </div>
  <div class="col-2">
    <CCard style="margin-left:10px">
            <div class="step001">
        <img src="@/assets/revenue.png"  style="width:27px;height:39px"/>
        <span class="head">Revenue</span>
        <span class="step002">{{symbol}} {{revenue}}</span>
        <span class="step003">Revenue</span>
      </div>

    </CCard>
  </div>
</div>
<div class="row" style="margin-top:-13px">
  <div class="col-2">
    <CCard>
      <div class="step001">
        <img src="@/assets/order.png"  style="width:35px;height:40px"/>
        <span class="head">Orders Received</span>
        <span class="step002"><a href="#/orderList" style="color:red;text-decoration:none">{{no_orders}}</a></span>
        <span class="step003">Orders recieved</span>
      </div>

    </CCard>
  </div>
  <div class="col-2">
    <CCard style="margin-left:10px">
      <div class="step001">
        <img src="@/assets/abandoned.png"  style="width:55px;height:39px"/>
        <span class="head">Added to cart</span>
        <span class="step002"><a href="#/abandonedCart" style="color:red;text-decoration:none">{{cart}}</a></span>
        <span class="step003">Cart Value</span>
      </div>

    </CCard>
  </div>
</div>

<!-- <h1>Welcome {{name}}</h1>
<h5>All systems are running smoothly!You have 3 unread alerts!</h5> -->

  </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";
import MainChartExample from './charts/MainChartExample'

export default {
  name: 'Dashboard',
  components: {
    MainChartExample
  },
  data () {
    return {
      datavalue : "",
      items : [],
      visit:[],
      visitors:0,
      no_orders : 0,
      revenue : 0,
      symbol : localStorage.getItem("symbol"),
      cart : 0,
      photoUrl : null,
      deliveryOption : null,
      regional : false,
      delivery : false,
      paymentmethod : null,
      payment : false,
      name:"",
        }


  },
  methods: {
    getCart(){
      const db = firebase.firestore();
      let temp = [];
      db.collection("Cart")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.data().shopID == firebase.auth().currentUser.uid) {
              temp.push(doc.data().quantity);
            }
          })
          this.cart = temp.reduce((a, b) => a + b, 0);
        })
    },
        getCustomerList() {
      const db = firebase.firestore();
      let temp = 0;
      db.collection("customer")
              .where("StoreId", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data())
              this.datavalue = {
                name:doc.data().nickname,
                phone:doc.data().phone,
              };
              // this.datavalue["id"] = temp;
              // temp = temp + 1;
              this.visit.push(this.datavalue);
              console.log(this.visit)
                                  this.visitors=this.visit.length;

console.log("Visitors",this.visitors)

          });
          console.log("over")
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getOrderList() {
      const db = firebase.firestore();
      let temp = [];
      let self = this;
      db.collection("orders")
        .orderBy("orderDate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log(firebase.auth().currentUser.uid)
            if(doc.data().orders){
              if (doc.data().orders[0].id == firebase.auth().currentUser.uid) {
              temp.push(parseInt(doc.data().total))
              this.datavalue = {
                total: doc.data().total
              };
              this.items.push(this.datavalue);
            }
            }


          });
          console.log("over");
          this.revenue = temp.reduce((a, b) => a + b, 0)
          this.no_orders = this.items.length;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getUserDetails() {
    //   const db = firebase.firestore();
    //   let temp;
    //   db.collection("users")
    //     .where("id", "==", firebase.auth().currentUser.uid)
    //     .get()
    //     .then((snapshot) => {
    //       snapshot.forEach((doc) => {   
    //         console.log(doc.data())
    //           this.id = doc.id;
    //           this.name=doc.data().nickname
    //           this.photoUrl = doc.data().photoUrl;
    //           this.deliveryOption = doc.data().deliveryOption;
    //           this.paymentmethod = doc.data().paymentmethod;
    //       })
    //       if(this.photoUrl || this.symbol){
    //         this.regional = true;
    //       }
    //       else{
    //         this.regional = false
    //       }
    //       if(this.deliveryOption){
    //         this.delivery = true
    //       }
    //       else{
    //         this.delivery = false
    //       }
    //       if(this.paymentmethod){
    //         this.payment = true
    //       }
    //       else{
    //         this.payment = false
    //       }
    //     });
    // },

  },
  created(){
  },
  mounted(){
    this.getOrderList();
    this.getCart();
    this.getCustomerList();
  }
}
</script>
<style scoped>
/* .card{
  margin-left: 10px;
  margin-right: 10px;
} */
.step001{
text-align:left !important;
flex-direction:column !important;
display:flex !important;
}
.step002{
color:red;
font-size: 13px !important;
font-weight: 600;

}
.step003{
color: #8392A7!important;
font-size:13px !important;
font-weight: 500;
}
.card{
  padding:1rem;
  width:9rem;
  height: 9rem;
}
.class-based-color{
  color: red
}
.col-2{
  width: 13.2222%;
}
.step000{
  margin-top:5px;
  margin-right: 5px;
margin-left:5px;
display: flex;
width:15rem;
height:auto;
  background:white !important;
  border:1px solid  gainsboro;
  border-radius:0.4rem;
  padding: 10px;
box-shadow: 0 2px 15px 0 rgb(0 0 0 / 30%) !important;
}
.head{
  font-size: 16px;
  font-weight: 500;
}
</style>
